import React, { useState } from 'react';

const translate = (key) => t(`quote_builder_widget.${key}`);

// "Select All Above" for materials the widget links to a catalog material (cartons: the widget draws the dieline at that
// material's thickness, which the owner's price does not hold). Each material gets its Material and its name here, as
// the single material's name step asks, and all are added with one press.
const SelectAllMaterialsStep = ({ title, materials, materialOptions, saving, errorMessage, onError, onSubmit, onBack }) => {
  const [selections, setSelections] = useState(() => Object.fromEntries(materials.map((material) => (
    [material.id, { widgetMaterialId: '', widgetLabel: material.widget_default_label || '' }]
  ))));

  const materialOptionLabel = (materialId) => {
    const option = materialOptions.find((candidate) => String(candidate.value) === String(materialId));
    return option ? option.label : '';
  };

  const changeSelection = (materialId, changes) => {
    setSelections((previous) => ({ ...previous, [materialId]: { ...previous[materialId], ...changes } }));
  };

  // As the single name step: the name follows the chosen Material until the owner types their own.
  const changeWidgetMaterial = (materialId, widgetMaterialId) => {
    const selection = selections[materialId];
    const followsMaterial = selection.widgetLabel.trim() === '' || selection.widgetLabel === materialOptionLabel(selection.widgetMaterialId);
    changeSelection(materialId, followsMaterial
      ? { widgetMaterialId, widgetLabel: materialOptionLabel(widgetMaterialId) }
      : { widgetMaterialId });
  };

  const submit = () => {
    const unfinished = materials.find((material) => !selections[material.id].widgetMaterialId || !selections[material.id].widgetLabel.trim());
    if (unfinished) {
      const missing = selections[unfinished.id].widgetMaterialId ? 'widget_label_required' : 'widget_material_required';
      onError(`${unfinished.description}: ${translate(missing)}`);
      return;
    }
    onSubmit(materials.map((material) => ({
      id: material.id,
      widget_label: selections[material.id].widgetLabel.trim(),
      widget_material_id: selections[material.id].widgetMaterialId,
    })));
  };

  return (
    <div>
      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <table className="table table-striped table-bordered-outside" style={{ marginTop: '10px' }}>
          <tbody>
            <tr>
              <th colSpan="2"><div className="float-left">{title}</div></th>
            </tr>
            {materials.map((material) => (
              <tr key={material.id} data-testid="widget-material-select-all">
                <td>
                  <strong>{material.description}</strong>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '5px' }}>
                    <label style={{ flex: '1 1 200px' }}>
                      {translate('widget_material')}
                      <select
                        className="form-control"
                        value={selections[material.id].widgetMaterialId}
                        onChange={(event) => changeWidgetMaterial(material.id, event.target.value)}
                      >
                        <option value="">{translate('select_material_option')}</option>
                        {materialOptions.map((option) => (
                          <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                      </select>
                    </label>
                    <label style={{ flex: '1 1 200px' }}>
                      {translate('widget_label')}
                      <input
                        type="text"
                        className="form-control"
                        value={selections[material.id].widgetLabel}
                        onChange={(event) => changeSelection(material.id, { widgetLabel: event.target.value })}
                        placeholder={translate('enter_widget_label')}
                      />
                    </label>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {errorMessage}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
        <button type="button" className="dct-button dct-button--primary" onClick={submit} disabled={saving}>
          {saving ? translate('saving') : translate('add_to_widget')}
        </button>
        <button type="button" className="dct-button dct-button--secondary" onClick={onBack}>
          {translate('back')}
        </button>
      </div>
    </div>
  );
};

export default SelectAllMaterialsStep;
